// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file fill.proto (package crossme, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file fill.proto.
 */
export const file_fill: GenFile = /*@__PURE__*/
  fileDesc("CgpmaWxsLnByb3RvEgdjcm9zc21lIo8CCgRGaWxsEhAKCGNvbXBsZXRlGAIgASgIEg0KBWNsb2NrGAMgASgDEg0KBW5vZGVzGAQgAygJEiEKBWNlbGxzGAUgAygLMhIuY3Jvc3NtZS5GaWxsLkNlbGwaUAoEQ2VsbBINCgVpbmRleBgBIAEoDRINCgVjbG9jaxgCIAEoAxINCgVvd25lchgDIAEoDRIMCgRmaWxsGAQgASgJEg0KBWZsYWdzGAUgASgNImIKBUZsYWdzEggKBE5PTkUQABIRCg1DSEVDS0VEX1JJR0hUEAESEQoNQ0hFQ0tFRF9XUk9ORxACEgoKBlBFTkNJTBAEEg0KCURJRF9DSEVDSxAIEg4KCkRJRF9SRVZFQUwQEEIUWhJjcm9zc21lLmFwcC9zcmMvcGJiBnByb3RvMw");

/**
 * @generated from message crossme.Fill
 */
export type Fill = Message<"crossme.Fill"> & {
  /**
   * @generated from field: bool complete = 2;
   */
  complete: boolean;

  /**
   * Lamport timestamp for this structure
   *
   * @generated from field: int64 clock = 3;
   */
  clock: bigint;

  /**
   * List of all node IDs represented in this fill.
   *
   * Node IDs are long, so we deduplicate on the wire by sending
   * int32 references into this array in the `owner` field.
   *
   * @generated from field: repeated string nodes = 4;
   */
  nodes: string[];

  /**
   * This list must be stored in order by `index`
   *
   * @generated from field: repeated crossme.Fill.Cell cells = 5;
   */
  cells: Fill_Cell[];
};

/**
 * Describes the message crossme.Fill.
 * Use `create(FillSchema)` to create a new message.
 */
export const FillSchema: GenMessage<Fill> = /*@__PURE__*/
  messageDesc(file_fill, 0);

/**
 * @generated from message crossme.Fill.Cell
 */
export type Fill_Cell = Message<"crossme.Fill.Cell"> & {
  /**
   * @generated from field: uint32 index = 1;
   */
  index: number;

  /**
   * @generated from field: int64 clock = 2;
   */
  clock: bigint;

  /**
   * @generated from field: uint32 owner = 3;
   */
  owner: number;

  /**
   * @generated from field: string fill = 4;
   */
  fill: string;

  /**
   * @generated from field: uint32 flags = 5;
   */
  flags: number;
};

/**
 * Describes the message crossme.Fill.Cell.
 * Use `create(Fill_CellSchema)` to create a new message.
 */
export const Fill_CellSchema: GenMessage<Fill_Cell> = /*@__PURE__*/
  messageDesc(file_fill, 0, 0);

/**
 * @generated from enum crossme.Fill.Flags
 */
export enum Fill_Flags {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: CHECKED_RIGHT = 1;
   */
  CHECKED_RIGHT = 1,

  /**
   * @generated from enum value: CHECKED_WRONG = 2;
   */
  CHECKED_WRONG = 2,

  /**
   * @generated from enum value: PENCIL = 4;
   */
  PENCIL = 4,

  /**
   * @generated from enum value: DID_CHECK = 8;
   */
  DID_CHECK = 8,

  /**
   * @generated from enum value: DID_REVEAL = 16;
   */
  DID_REVEAL = 16,
}

/**
 * Describes the enum crossme.Fill.Flags.
 */
export const Fill_FlagsSchema: GenEnum<Fill_Flags> = /*@__PURE__*/
  enumDesc(file_fill, 0, 0);

